import React from 'react'
import Animations from '../../utilities/Animations';
import ScrollService from '../../utilities/ScrollService';
import { FooterM } from '../Footer/FooterM';


export const Contact = (props) => {
  let fadeInScreenHand = (screen) => {
    if (screen.fadeInScreen !== props.id) return
    Animations.animations.fadeInscreen(props.id);
  };
  const fadeInSub = ScrollService.currScreenFadeIn.subscribe(fadeInScreenHand);
  return (
    <div id={props.id || ""} style={{background:"#2d4d4c",marginBottom:"-30px"}} >
      <FooterM/>
    </div>
  )
}
